import React, { useState, useEffect, useRef } from 'react';
import NotificationAlert from './NotificationAlert.js';

export default () => {

  const notificationAlertRef = useRef(null);
  const [action, setAction] = useState();
  const [notif] = useState(
    <div className="rna-container">
      <NotificationAlert ref={notificationAlertRef} />
    </div>
  );

  const notify = ({id = null, place, type, message, icon = `nc-icon nc-bell-55`}) => {

    const options = {
      id, place, type, icon,
      autoDismiss: 7,
      message: (
        <div>
          <div>{message}</div>
        </div>
      ),
    };

    notificationAlertRef.current.notificationAlert(options);
  }

  useEffect(() => {

    if (action) notify(action);

    return () => {};

  }, [action]);

  return [notif, setAction];

}